/**
 * Asynchronously loads the component for PiecripHomePage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripHomePage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripHomePage
);

